import { lazy } from 'react';
import { Routes, Route, useLocation } from 'react-router';
import { isMobile } from 'react-device-detect';
import { useTranslation } from 'react-i18next';
import api from '@apis/api';
import {
    AppPicker,
    ErrorDisplay,
    Login,
    NotFound,
    NotMobileSupported,
    PrivateRoute,
    Splash as SplashScreen,
} from '@commonClient/components';
import { JwtLicenses } from './enums';
import emptyConfig from '@apis/appConfigs/initConfig.json';


const AppManager = lazy(() => import('./AppManager/App'));
const AppEmployee = lazy(() => import('./AppEmployee/App'));
const AppAdmin = lazy(() => import('./AppAdmin/App'));
const AppAdp = lazy(() => import('./AppAdmin/Adp'));

const CoreRoutes = () => {
    const { data: configs = emptyConfig, error, isLoading } = api.useGetPublicConfigsQuery();
    const { t } = useTranslation('common');
    const location = useLocation();

    if (isLoading) {
        return <SplashScreen />;
    }

    if (error) {
        let errorMessage = '';
        if (error.data?.Message) {
            errorMessage = error.data.Message + t('errors.specificDomainError');
        } else {
            errorMessage = t('errors.genericError')
        }
        return <ErrorDisplay message={errorMessage} />;
    }

    if (isMobile){
        const rolePath = location.pathname.toLocaleLowerCase();
        if (rolePath.includes('admin') || rolePath.includes('manager')) {
            return (
                <NotMobileSupported role={rolePath} />
            );
        }
    }

    const employeeRedirectUrl = configs.employeeRedirectUrl;
    const managerRedirectUrl = configs.managerRedirectUrl;
    const adminRedirectUrl = configs.adminRedirectUrl;

    return (
        <Routes>
            <Route
                path="/login/:target"
                element={<Login />}
            />
            <Route
                path="/"
                element={<AppPicker />}
            />
            <Route
                path="/employee/*"
                element={(
                    <PrivateRoute
                        redirectUrl={employeeRedirectUrl}
                        configs={configs}
                        requiredLicense={JwtLicenses.Employee}
                    >
                        <AppEmployee />
                    </PrivateRoute>
                )}
            />
            <Route
                path="/manager/*"
                element={(
                    <PrivateRoute
                        redirectUrl={managerRedirectUrl}
                        configs={configs}
                        requiredLicense={JwtLicenses.Manager}
                    >
                        <AppManager />
                    </PrivateRoute>
                )}
            />
            <Route
                path="/admin/*"
                element={(
                    <PrivateRoute
                        redirectUrl={adminRedirectUrl}
                        configs={configs}
                        requiredLicense={JwtLicenses.Admin}
                    >
                        <AppAdmin />
                    </PrivateRoute>
                )}
            />
            <Route
                path="/adp"
                element={(
                    <PrivateRoute
                        redirectUrl={adminRedirectUrl}
                        configs={configs}
                    >
                        <AppAdp />
                    </PrivateRoute>
                )}
            />
            <Route
                path="*"
                element={<NotFound />}
            />
        </Routes>
    );
};

export default CoreRoutes;
